import { render, staticRenderFns } from "./LegoProgressBar.vue?vue&type=template&id=56b8897f&scoped=true"
import script from "./LegoProgressBar.vue?vue&type=script&lang=js"
export * from "./LegoProgressBar.vue?vue&type=script&lang=js"
import style0 from "./LegoProgressBar.vue?vue&type=style&index=0&id=56b8897f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8897f",
  null
  
)

export default component.exports